import { myInput } from '../input.js';
import { historie } from '../history.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { modes } from '../modes.js';

export const drag = {};

drag.start = () => {
    if (settings.pattern.noDrag !== undefined) return;
    if (!settings.showInactiveBeads) {
        settings.showInactiveBeads = true;
        beads.refreshCanvas();
    }
    beads.selectedBeads = [];
    drag.recentBead = null;
    if (myInput.ALT.isDown || modes.cloneActive) {
        drag.clone = true;
    } else {
        drag.clone = false;
    }
    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.selected) {
            if (drag.clone) {
                beads.assign(bead.temp, bead);
            } else {
                bead.temp.active = false;
                bead.temp.style = null;
            }
            bead.temp.selected = false;
            beads.selectedBeads.push(Object.assign({}, bead));
        } else {
            beads.assign(bead.temp, bead);
        }

        bead.temp.processed = false;
    });

    beads.recentMask = {
        old: [],
        new: [],
        firstTime: true
    };

    modes.start('drag');
};

drag.doDrag = () => {
    if (game.input.activePointer.isDown) {
        let currentBead = beads.recentlyOverBead;
        if (currentBead !== undefined) {
            if (currentBead !== drag.recentBead) {
                drag.recentBead = currentBead;

                let offsetX = currentBead.column - beads.mostRecentClickedBead.column;
                let offsetY = currentBead.row - beads.mostRecentClickedBead.row;

                beads.selectedBeads.forEach(bead => {
                    let shiftX = 0;
                    let maskedBead;
                    if (settings.pattern.brickDrag) {
                        if (beads.rowOffset[beads.mostRecentClickedBead.row] == 1) {
                            if (beads.rowOffset[currentBead.row] == 0) {
                                if (beads.rowOffset[bead.row] == 0) {
                                    shiftX = 1;
                                }
                            }
                        } else {
                            if (beads.rowOffset[currentBead.row] == 1) {
                                if (beads.rowOffset[bead.row] == 1) {
                                    shiftX = -1;
                                }
                            }
                        }
                    }

                    if (bead.row + offsetY < settings.rows &&
                        (bead.row + offsetY >= 0)) {
                        maskedBead = beads.findBead(bead.column + offsetX + shiftX, bead.row + offsetY);

                        if (maskedBead !== undefined) {
                            maskedBead.temp.processed = true;
                            beads.recentMask.new.push(maskedBead);

                            beads.assign(maskedBead, bead, true);
                        }
                    }
                });

                beads.recentMask.old.forEach(bead => {
                    if (!bead.temp.processed) {
                        beads.assign(bead, bead.temp, true);
                    }
                });

                beads.recentMask.old = beads.recentMask.new;
                beads.recentMask.new = [];

                beads.arr.forEach(bead => {
                    if (bead.ignore) return;
                    if (bead.temp.processed) {
                        bead.temp.processed = false;
                    }
                });
            }
        }
    } else {

        // finish dragging the beads (reset the temp. colors and change the state)

        beads.arr.forEach(bead => {
            bead.temp = {};
        });
        modes.restoreMode();
        historie.addAction();
    }
};
